export default __webpack_public_path__ + "static/media/ic_republic_of_the_congo.eb50ac8b.svg";